module.exports = __webpack_public_path__ + "img/icon_peixun.41b8fc16.png";